export enum UserPermissions {
  CAN_MANAGE_REGION = 'can_manage_region',
  CAN_CREATE_REGION = 'can_create_region',
  CAN_VIEW_REGION = 'can_view_region',
  CAN_EDIT_REGION = 'can_edit_region',
  CAN_DELETE_REGION = 'can_delete_region',

  CAN_ASSIGN_REGIONS_TO_HR = 'can_assign_regions_to_hr',
  CAN_MANAGE_CANDIDATE_VISIBILITY = 'can_manage_candidate_visibility',

  CAN_CREATE_JOB = 'can_create_job',
  CAN_VIEW_JOB = 'can_view_job',
  CAN_EDIT_JOB = 'can_edit_job',
  CAN_DELETE_JOB = 'can_delete_job',

  CAN_CREATE_STATUS = 'can_create_status',
  CAN_VIEW_STATUS = 'can_view_status',
  CAN_EDIT_STATUS = 'can_edit_status',
  CAN_DELETE_STATUS = 'can_delete_status',

  CAN_CREATE_SOURCE = 'can_create_source',
  CAN_VIEW_SOURCE = 'can_view_source',
  CAN_EDIT_SOURCE = 'can_edit_source',
  CAN_DELETE_SOURCE = 'can_delete_source',

  CAN_CREATE_TAG = 'can_create_tag',
  CAN_VIEW_TAG = 'can_view_tag',
  CAN_EDIT_TAG = 'can_edit_tag',
  CAN_DELETE_TAG = 'can_delete_tag',

  CAN_VIEW_ROLE = 'can_view_roles',
  CAN_VIEW_PERMISSIONS = 'can_view_permissions',
  CAN_VIEW_ALL_NOTIFICATION = 'can_view_all_notifications',

  CAN_CREATE_CANDIDATE = 'can_create_candidate',
  CAN_EDIT_CANDIDATE = 'can_edit_candidate',
  CAN_VIEW_CANDIDATE = 'can_view_candidate',
  CAN_DELETE_CANDIDATE = 'can_delete_candidate',

  CAN_CREATE_CANDIDATE_RECORD = 'can_create_candidate_record',
  CAN_EDIT_CANDIDATE_RECORD = 'can_edit_candidate_record',
  CAN_VIEW_CANDIDATE_RECORD = 'can_view_candidate_record',
  CAN_DELETE_CANDIDATE_RECORD = 'can_delete_candidate_record',

  CAN_VIEW_CANDIDATE_RECORD_HISTORY = 'can_view_candidate_record_history',
  CAN_VIEW_CANDIDATE_INTERVIEWS_HISTORY = 'can_view_candidate_interviews_history',
  CAN_VIEW_GOOGLE_MEET_INTERVIEW = 'can_view_google_meet_interview',
  CAN_CREATE_GOOGLE_MEET_INTERVIEW = 'can_create_google_meet_interview',
  CAN_EDIT_GOOGLE_MEET_INTERVIEW = 'can_edit_google_meet_interview',
  CAN_DELETE_GOOGLE_MEET_INTERVIEW = 'can_delete_google_meet_interview',
  CAN_VIEW_ATTACHMENT = 'can_view_attachment',
  CAN_MANAGE_ATTACHMENT = 'can_manage_attachment',
  CAN_VIEW_EVENT = 'can_view_event',
  CAN_CREATE_EVENT = 'can_create_event',
  CAN_VIEW_REPORT = 'can_view_report',
  CAN_VIEW_GROUPED_REPORT = 'can_view_grouped_report',
  CAN_VIEW_INTERNSHIP = 'can_view_internship',
  CAN_CREATE_INTERNSHIP = 'can_create_internship',
  CAN_EDIT_INTERNSHIP = 'can_edit_internship',
  CAN_DELETE_INTERNSHIP = 'can_delete_internship',
  CAN_VIEW_INTERNSHIP_PEOPLE = 'can_view_internship_people',
  CAN_MANAGE_INTERNSHIP_PEOPLE = 'can_manage_internship_people',
  CAN_VIEW_INTERNSHIP_STATUS = 'can_view_internship_status',
  CAN_CREATE_INTERNSHIP_STATUS = 'can_create_internship_status',
  CAN_EDIT_INTERNSHIP_STATUS = 'can_edit_internship_status',
  CAN_DELETE_INTERNSHIP_STATUS = 'can_delete_internship_status',
}
